import axios from 'axios'
import { useEffect, useState } from 'react'
import { user } from '../services/config';

function LogoutScreen({ setProfileState }) {
    const [loggedout, setLoggedout] = useState(false)

    useEffect(() => {
        const logOut = () => {
            localStorage.removeItem('projectRole')
            setProfileState({ profile: {} })
        }
        async function logout() {
            await axios.get(user.logout)
                .then(() => {
                    logOut()
                    setLoggedout(true)
                })
                .catch(
                    function (error) {
                        console.log(error)
                    }
                )
        }
        logout()
    }, [setProfileState])


    return (
        <div className='mt-5 text-center'>
            {!!loggedout && "Vous êtes déconnecté !"}
        </div>
    )
}

export default LogoutScreen